export default __webpack_public_path__ + "static/media/office-building.71cc7747.svg";